module.exports = __webpack_public_path__ + "static/person_looking-780a957a1adf32a9a5725bac96c74958.png";